<template>
  <header class="panel-heading clearfix">
    <h3 class="panel-title">
      <span v-if="hitPercentageBeingComputed">
        <em>Computing hit percentage...</em>
      </span>
      <span v-else-if="hitPercentageUpToDate">
        <span>{{ hitPercentage }}%</span><span> of hands hit</span><span> the {{ street }}</span>
      </span>
      <span v-else>
        <em>Run simulation to update hit percentage for the {{ street }}</em>
      </span>
    </h3>
    <button class="btn btn-default clear-checks" v-bind:disabled="!authorized" v-on:click="$emit('clearAllChecks')">
      <span class="full-text">Clear checkboxes</span>
      <span class="partial-text">Clear</span>
    </button>
    <div class="dropdown set-checks-to-default">
      <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" v-bind:disabled="!authorized">
        <span class="full-text">Set checkboxes <span class="caret"></span></span>
        <span class="partial-text">Checkboxes <span class="caret"></span></span>
      </button>
      <ul class="dropdown-menu">
        <li v-on:click="$emit('selectAllChecks')"><a>Select all</a></li>
        <li role="separator" class="divider"></li>
        <li class="dropdown-header">Continuing range (call or raise)</li>
        <li v-on:click="$emit('setChecksToDefault', 'tight')"><a>Tight</a></li>
        <li v-on:click="$emit('setChecksToDefault', 'straightforward')"><a>Straightforward</a></li>
        <li v-on:click="$emit('setChecksToDefault', 'loose')"><a>Loose</a></li>
        <li v-if="userDefinedFilters.length > 0" class="dropdown-header">User defined filters</li>
        <li
          v-for="(userDefinedFilter, index) in userDefinedFilters"
          v-bind:key="userDefinedFilter.name + '-' + index"
          v-on:click="$emit('setChecksBasedOnUserDefinedFilter', userDefinedFilter.name)"
        >
          <a>{{ userDefinedFilter.name }}</a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: 'five-card-hands-section-header',
  props: [
    'hitPercentageBeingComputed',
    'hitPercentageUpToDate',
    'hitPercentage',
    'stateName',
    'authorized',
  ],
  computed: {
    userDefinedFilters: function () {
      return this.$store.state.account.user.settings.hitCalculator.userDefinedFilters;
    },
    street: function () {
      if (this.stateName === 'afterFlop') {
        return 'flop';
      } else if (this.stateName === 'afterTurn') {
        return 'turn';
      } else if (this.stateName === 'afterRiver') {
        return 'river';
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .panel-heading {
    h3 {
      float: left;
      position: relative;
      top: 10px;
    }

    .set-checks-to-default, .clear-checks {
      float: right;
      margin-left: 10px;
    }

    .partial-text {
      display: none;
    }
  }

  .dropdown-menu {
    li {
      cursor: pointer;

      a {
        padding: 5px 20px;
      }

      @media (max-device-width: 768px) {
        a {
          padding: 15px 20px;
        }
      }
    }
  }

  // hide text in heading so that it fits on small screens
  @media (max-width: 550px) {
    .panel-heading {
      .full-text {
        display: none;
      }

      .partial-text {
        display: inline;
      }
    }
  }

  @media (max-width: 430px) {
    .panel-title span:nth-of-type(2) {
      display: none;
    }
  }

  @media (max-width: 365px) {
    h3.panel-title {
      font-size: 12px;
    }
  }

  @media (max-width: 343px) {
    h3.panel-title, .panel-heading button {
      font-size: 10.5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/five-card-hands-section/header.vue